import ProtectedRoute from "@components/ProtectedRoute";
import { useIsInclude } from "src/router/RoutersCst";

import BudgetManagement from "@pages/Contents/BudgetManagement";
import Budgets from "@pages/Contents/BudgetManagement/Budget/Budgets";
import AddBudgets from "@pages/Contents/BudgetManagement/Budget/AddBudgets";
import EditBudgets from "@pages/Contents/BudgetManagement/Budget/EditBudgets";
import Setup from "@pages/Contents/BudgetManagement/Setup";
import CostCenter from "@pages/Contents/BudgetManagement/Setup/CostCenter";
import AddCostCenter from "@pages/Contents/BudgetManagement/Setup/CostCenter/AddCostCenter";
import EditCostCenter from "@pages/Contents/BudgetManagement/Setup/CostCenter/EditCostCenter";
import BankAccount from "@pages/Contents/BudgetManagement/Setup/BankAccount";
import AddBankAccount from "@pages/Contents/BudgetManagement/Setup/BankAccount/AddBankAccount";
import EditBankAccount from "@pages/Contents/BudgetManagement/Setup/BankAccount/EditBankAccount";
import Customer from "@pages/Contents/BudgetManagement/Setup/Customer";
import AddCustomer from "@pages/Contents/BudgetManagement/Setup/Customer/AddCustomer";
import EditCustomer from "@pages/Contents/BudgetManagement/Setup/Customer/EditCustomer";
import Scope from "@pages/Contents/BudgetManagement/Setup/Scope";
import AddScope from "@pages/Contents/BudgetManagement/Setup/Scope/AddScope";
import EditScope from "@pages/Contents/BudgetManagement/Setup/Scope/EditScope";
import Project from "@pages/Contents/BudgetManagement/Project";
import AddProject from "@pages/Contents/BudgetManagement/Project/DetailsProject/AddProject";
import DetailProject from "@pages/Contents/BudgetManagement/Project/TabsProject";
import Supplier from "@pages/Contents/BudgetManagement/Setup/Supplier";
import AddSupplier from "@pages/Contents/BudgetManagement/Setup/Supplier/AddSupplier";
import EditSupplier from "@pages/Contents/BudgetManagement/Setup/Supplier/EditSupplier";
import Contract from "@pages/Contents/BudgetManagement/Setup/Contract";
import AddContract from "@pages/Contents/BudgetManagement/Setup/Contract/AddContract";
import EditContract from "@pages/Contents/BudgetManagement/Setup/Contract/EditContract";
import Accounting from "@pages/Contents/BudgetManagement/Accounting";
import GoodsReceiptsCost from "@pages/Contents/BudgetManagement/Project/CostProject/GoodsReceiptsCost";
import AddGoodReceipt from "@pages/Contents/BudgetManagement/Project/CostProject/GoodsReceiptsCost/AddGoodReceipt";
import EditGoodReceipt from "@pages/Contents/BudgetManagement/Project/CostProject/GoodsReceiptsCost/EditGoodReceipt";

const useBudgetManagementRoutes = () => {
  const { isInclude } = useIsInclude();
  return {
    path: "budget-management",
    children: [
      {
        index: true,
        path: "",
        element: (
          <ProtectedRoute
            isAllowed={isInclude("corporate&&usermgmt.budget.read")}
          >
            <BudgetManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: "budgets",
        children: [
          {
            index: true,
            path: "",
            element: (
              <ProtectedRoute
                isAllowed={isInclude("corporate&&usermgmt.budget.read")}
              >
                <Budgets />
              </ProtectedRoute>
            ),
          },
          {
            path: "add",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&usermgmt.budget.read&&usermgmt.budget.write",
                )}
              >
                <AddBudgets />
              </ProtectedRoute>
            ),
          },
          {
            path: "edit/:idBudget",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&usermgmt.budget.read&&usermgmt.budget.write",
                )}
              >
                <EditBudgets />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: "projects",
        children: [
          {
            index: true,
            path: "",
            element: (
              <ProtectedRoute
                isAllowed={isInclude("corporate&&usermgmt.budget.read")}
              >
                <Project />
              </ProtectedRoute>
            ),
          },
          {
            path: "add",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&usermgmt.budget.read&&usermgmt.budget.write",
                )}
              >
                <AddProject />
              </ProtectedRoute>
            ),
          },
          {
            path: "edit/:idProject",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&usermgmt.budget.read&&usermgmt.budget.write",
                )}
              >
                <DetailProject />
              </ProtectedRoute>
            ),
          },
          {
            path: "edit/:idProject/goods-receipts/:idCost",
            children: [
              {
                index: true,
                path: "",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude(
                      "corporate&&usermgmt.budget.read&&usermgmt.budget.write",
                    )}
                  >
                    <GoodsReceiptsCost />
                  </ProtectedRoute>
                ),
              },
              {
                path: "add",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude(
                      "corporate&&usermgmt.budget.read&&usermgmt.budget.write",
                    )}
                  >
                    <AddGoodReceipt />
                  </ProtectedRoute>
                ),
              },
              {
                path: "edit/:idReceipt",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude(
                      "corporate&&usermgmt.budget.read&&usermgmt.budget.write",
                    )}
                  >
                    <EditGoodReceipt />
                  </ProtectedRoute>
                ),
              },
            ],
          },
        ],
      },
      {
        path: "accounting",
        children: [
          {
            index: true,
            path: "",
            element: (
              <ProtectedRoute
                isAllowed={isInclude("corporate&&usermgmt.budget.read")}
              >
                <Accounting />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: "setup",
        children: [
          {
            index: true,
            path: "",
            element: (
              <ProtectedRoute isAllowed={true}>
                <Setup />
              </ProtectedRoute>
            ),
          },
          {
            path: "cost-centers",
            children: [
              {
                index: true,
                path: "",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude("corporate&&usermgmt.budget.read")}
                  >
                    <CostCenter />
                  </ProtectedRoute>
                ),
              },
              {
                path: "add",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude(
                      "corporate&&usermgmt.budget.read&&usermgmt.budget.write",
                    )}
                  >
                    <AddCostCenter />
                  </ProtectedRoute>
                ),
              },
              {
                path: "edit/:idCostCenter",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude(
                      "corporate&&usermgmt.budget.read&&usermgmt.budget.write",
                    )}
                  >
                    <EditCostCenter />
                  </ProtectedRoute>
                ),
              },
            ],
          },
          {
            path: "accounts",
            children: [
              {
                index: true,
                path: "",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude("corporate&&usermgmt.budget.read")}
                  >
                    <BankAccount />
                  </ProtectedRoute>
                ),
              },
              {
                path: "add",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude(
                      "corporate&&usermgmt.budget.read&&usermgmt.budget.write",
                    )}
                  >
                    <AddBankAccount />
                  </ProtectedRoute>
                ),
              },
              {
                path: "edit/:idBankAccount",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude(
                      "corporate&&usermgmt.budget.read&&usermgmt.budget.write",
                    )}
                  >
                    <EditBankAccount />
                  </ProtectedRoute>
                ),
              },
            ],
          },
          {
            path: "customers",
            children: [
              {
                index: true,
                path: "",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude("corporate&&usermgmt.budget.read")}
                  >
                    <Customer />
                  </ProtectedRoute>
                ),
              },
              {
                path: "add",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude(
                      "corporate&&usermgmt.budget.read&&usermgmt.budget.write",
                    )}
                  >
                    <AddCustomer />
                  </ProtectedRoute>
                ),
              },
              {
                path: "edit/:idCustomer",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude(
                      "corporate&&usermgmt.budget.read&&usermgmt.budget.write",
                    )}
                  >
                    <EditCustomer />
                  </ProtectedRoute>
                ),
              },
            ],
          },
          {
            path: "scopes",
            children: [
              {
                index: true,
                path: "",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude("corporate&&usermgmt.budget.read")}
                  >
                    <Scope />
                  </ProtectedRoute>
                ),
              },
              {
                path: "add",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude(
                      "corporate&&usermgmt.budget.read&&usermgmt.budget.write",
                    )}
                  >
                    <AddScope />
                  </ProtectedRoute>
                ),
              },
              {
                path: "edit/:idScope",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude(
                      "corporate&&usermgmt.budget.read&&usermgmt.budget.write",
                    )}
                  >
                    <EditScope />
                  </ProtectedRoute>
                ),
              },
            ],
          },
          {
            path: "suppliers",
            children: [
              {
                index: true,
                path: "",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude("corporate&&usermgmt.budget.read")}
                  >
                    <Supplier />
                  </ProtectedRoute>
                ),
              },
              {
                path: "add",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude(
                      "corporate&&usermgmt.budget.read&&usermgmt.budget.write",
                    )}
                  >
                    <AddSupplier />
                  </ProtectedRoute>
                ),
              },
              {
                path: "edit/:idSupplier",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude(
                      "corporate&&usermgmt.budget.read&&usermgmt.budget.write",
                    )}
                  >
                    <EditSupplier />
                  </ProtectedRoute>
                ),
              },
            ],
          },
          {
            path: "contracts",
            children: [
              {
                index: true,
                path: "",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude("corporate&&usermgmt.budget.read")}
                  >
                    <Contract />
                  </ProtectedRoute>
                ),
              },
              {
                path: "add",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude(
                      "corporate&&usermgmt.budget.read&&usermgmt.budget.write",
                    )}
                  >
                    <AddContract />
                  </ProtectedRoute>
                ),
              },
              {
                path: "edit/:idContract",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude(
                      "corporate&&usermgmt.budget.read&&usermgmt.budget.write",
                    )}
                  >
                    <EditContract />
                  </ProtectedRoute>
                ),
              },
            ],
          },
        ],
      },
    ],
  };
};

export default useBudgetManagementRoutes;
